import { isPlainLabelTree, getLabelText } from '../../../_utils/plain-label.utils.js';
import { canonicalizeAncestorsOnlySelection } from './tree-select-checkbox-selection.utils.js';
import { shouldUseExternalSelectedValueLayout } from './tree-select.utils.js';

function isAncestorsOnlyCheckboxMode(checkboxSelectionBehavior, selectionMode) {
  return checkboxSelectionBehavior === 'ancestorsOnly' && selectionMode === 'checkbox';
}
function getTreeSelectSelectionFlags(_ref) {
  let {
    checkboxSelectionBehavior,
    display,
    inputValueTemplate,
    options,
    selectedValueLayout,
    selectionMode
  } = _ref;
  const ancestorsOnlyCheckboxMode = isAncestorsOnlyCheckboxMode(checkboxSelectionBehavior, selectionMode);
  const externalSelectedValueLayout = shouldUseExternalSelectedValueLayout(selectionMode, selectedValueLayout);
  const overflowValueTemplate = !inputValueTemplate && !externalSelectedValueLayout && display !== 'chip' && isPlainLabelTree(options, node => getLabelText(node.label), node => node.children);
  return {
    isAncestorsOnlyCheckboxMode: ancestorsOnlyCheckboxMode,
    shouldBuildNodeMaps: ancestorsOnlyCheckboxMode || externalSelectedValueLayout || overflowValueTemplate,
    shouldUseOverflowValueTemplate: overflowValueTemplate,
    useExternalSelectedValueLayout: externalSelectedValueLayout
  };
}
function getCanonicalTreeSelectValue(value, nodeMaps, ancestorsOnlyCheckboxMode) {
  if (!ancestorsOnlyCheckboxMode || !nodeMaps) {
    return value;
  }
  return canonicalizeAncestorsOnlySelection(value, nodeMaps);
}

export { getCanonicalTreeSelectValue, getTreeSelectSelectionFlags, isAncestorsOnlyCheckboxMode };
